import {SingletonService} from '@/common/dependency.configs'
import {injectable, inject} from 'inversify'
import LanguageFactory from '@/common/services/Language/LanguageFactory'

@SingletonService
@injectable()
class BltUiKeyFilter {
  constructor(
    @inject(LanguageFactory)
    private languageFactory: LanguageFactory
  ) {}
  bltUiKey(text: string) {
    return this.languageFactory.getSynchronous(text)
  }
}
export default BltUiKeyFilter
